import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsTabletOrDesktoMQ } from 'core/modules/MediaQueries/selectors';
import { selectUserIsIdentified } from 'core/selectors/user';
import { selectFeaturedDealsConfig } from 'core/modules/FeaturedDeals/selectors';

import FeaturedDealDesktop from './FeaturedDealDesktop/FeaturedDealDesktop';
import FeaturedDealMobileRounded from './FeaturedDealMobileRounded/FeaturedDealMobileRounded';
import FeaturedDealMobileClassic from './FeaturedDealMobileClassic/FeaturedDealMobileClassic';

function FeaturedDeal({ offer }) {
  const config = useSelector(selectFeaturedDealsConfig);
  const isTabletOrDesktoMQ = useSelector(selectIsTabletOrDesktoMQ);
  const isUserIdentified = useSelector(selectUserIsIdentified);
  const { getShouldUseFeaturedDealsRoundedView } = config;
  const shouldUseFeaturedDealsRoundedView = getShouldUseFeaturedDealsRoundedView(isUserIdentified);

  if (isTabletOrDesktoMQ) {
    return (<FeaturedDealDesktop offer={offer} />);
  }

  if (shouldUseFeaturedDealsRoundedView) {
    return (<FeaturedDealMobileRounded offer={offer} />);
  }

  return (
    <FeaturedDealMobileClassic offer={offer} />
  );
}

export default FeaturedDeal;
